import { render } from "./ManageTest.vue?vue&type=template&id=53aa3290&scoped=true"
import script from "./ManageTest.vue?vue&type=script&lang=js"
export * from "./ManageTest.vue?vue&type=script&lang=js"

import "./ManageTest.vue?vue&type=style&index=0&id=53aa3290&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53aa3290"]])

export default __exports__